// Mongo references reach the client in two shapes: a bare ObjectId string
// (unpopulated) or a full document (populated). GET /posts/:postId populates
// `topic` and `event`, so echoing them straight back into PUT /posts sent an
// object where the server's Zod schema requires an id string — the request
// failed with `Expected string, received object at "body.topic"` and the edit
// could never be saved. Normalise at the boundary instead of at each caller.

type PopulatedReference = { _id?: unknown; id?: unknown };

export type Reference = string | PopulatedReference | null | undefined;

export const toReferenceId = (reference: Reference): string | null => {
  if (!reference) return null;
  if (typeof reference === 'string') return reference || null;

  const identifier = reference._id ?? reference.id;
  return typeof identifier === 'string' && identifier ? identifier : null;
};
